module.exports = __webpack_public_path__ + "img/logo.245e684c.svg";